const undockReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_UNDOCK_CONVERSATION':
      return {
        ...state,
        conversation: action.payload,
      }
    case 'SET_UNDOCK_CONVERSATIONS':
      return {
        ...state,
        conversations: action.payload,
      }
    case 'SET_UNDOCK_ACTIVE_CONVERSATION':
      return {
        ...state,
        activeConversation: action.payload,
      }
    case 'SET_UNDOCK_DATA':
      return {
        ...state,
        data: action.payload,
      }
    case 'SET_UNDOCK_TREEOFKNOWLEDGE':
      return {
        ...state,
        treeOfKnowledge: action.payload,
      }
    case 'DELETE_UNDOCK':
      const conversationId = action.payload
      const { [conversationId]: chatDeleted, ...newChats } = state.conversations
      return {
        ...state,
        conversations: newChats,
      }
    default:
      return state
  }
}

export default undockReducer
